import { Box, Card, Fade, FilledInput, FormControl, InputAdornment, InputLabel, ListItemText } from "@mui/material";
import { ReactNode, useContext, useEffect, useRef, useState } from "react";
import CloseIcon from 'remixicon-react/CloseFillIcon';
import SendIcon from 'remixicon-react/SendPlane2FillIcon';
import { ConfigContext } from "../../App/App";

export type ActionButtonProps = {
    icon: ReactNode;
    primaryText: string;
    secondaryText: string;
    onActionEnter: (inputText: string) => void
}

function ActionButton(props: { actionButtonProps: ActionButtonProps }) {

    const [showInput, setShowInput] = useState(false)
    const inputRef = useRef<HTMLElement>();
    const config = useContext(ConfigContext);
    const [inputMessage, setInputMessage] = useState('');

    const toggleShowInput = () => {
        setShowInput(!showInput)
    }

    useEffect(() => {
        if (showInput) {
            if (inputRef?.current) {
                inputRef.current.focus()
            }
        }
    }, [showInput])


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputMessage(event.target.value);
    };

    const performAction = () => {
        let newInput = inputMessage
        props.actionButtonProps.onActionEnter(newInput);
        setInputMessage("");
        toggleShowInput();
    }

    const onKeyUp = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            const { target } = event;
            (target as HTMLInputElement).blur();
            performAction()
        }
    }


    return (
        <Card sx={{ height: '75px', display: 'flex', alignItems: 'center', background: config.TextInputBackground }} >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}>
                    <Box sx={{ mx: 2, display: 'flex', alignItems: 'center' }}>
                        {!showInput &&
                            <Box
                                component="button"
                                type="button"
                                aria-label={`Open ${props.actionButtonProps.primaryText}`}
                                onClick={toggleShowInput}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    color: 'inherit',
                                }}
                            >
                                {props.actionButtonProps.icon}
                            </Box>
                        }
                        {showInput &&
                            <Box
                                component="button"
                                type="button"
                                aria-label="Close input"
                                onClick={toggleShowInput}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    color: 'inherit',
                                }}
                            >
                                <CloseIcon color="primary" />
                            </Box>

                        }
                    </Box>
                    {!showInput &&
                        <Fade in={true}>
                            <Box
                                component="button"
                                type="button"
                                aria-label={`Open ${props.actionButtonProps.primaryText}`}
                                onClick={toggleShowInput}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                    width: '100%',
                                    flex: 1,
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    color: 'inherit',
                                }}
                            >
                                <ListItemText
                                    primary={props.actionButtonProps.primaryText}
                                    secondary={props.actionButtonProps.secondaryText ? props.actionButtonProps.secondaryText : null}
                                />
                            </Box>
                        </Fade>
                    }
                    {showInput &&
                        <FormControl variant="filled" fullWidth sx={{ height: '100%' }}>
                            <InputLabel htmlFor="my-input">{props.actionButtonProps.primaryText}</InputLabel>
                            <FilledInput sx={{ height: '100%', boxShadow: 'none' }} id="my-input" aria-describedby="my-helper-text" disableUnderline inputRef={inputRef}
                                endAdornment={
                                    <InputAdornment position="end" >
                                        <Box
                                            component="button"
                                            type="button"
                                            onClick={performAction}
                                            aria-label={`Submit ${props.actionButtonProps.primaryText}`}
                                            sx={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                padding: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                color: 'inherit',
                                            }}
                                        >
                                            <SendIcon size={16} />
                                        </Box>
                                    </InputAdornment>
                                }
                                onKeyUp={onKeyUp}
                                value={inputMessage}
                                onChange={handleChange} />
                        </FormControl>
                    }
            </Box>
        </Card >
    );
}
export default ActionButton; 